var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [_vm._v("Firmwares")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              attrs: { disabled: !!_vm.firmwareSupportMsg },
              nativeOn: {
                click: function ($event) {
                  return _vm.getData.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _vm.firmwareSupportMsg
      ? _c("h1", { staticStyle: { "text-align": "center" } }, [
          _vm._v("\n    " + _vm._s(_vm.firmwareSupportMsg) + "\n  "),
        ])
      : _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "card-content",
          },
          [
            _c(
              "el-row",
              {
                staticClass: "firmware-components-wrapper",
                attrs: { gutter: 10 },
              },
              _vm._l(_vm.components, function (comp, index) {
                return _c(
                  "el-col",
                  {
                    key: index,
                    staticClass: "firmware-component-input",
                    attrs: { span: 8 },
                  },
                  [
                    _c("FirmwareComponentInput", {
                      attrs: {
                        "edit-mode": false,
                        options: _vm.firmwaresOptions.components[comp.name],
                        component: comp,
                        "default-firmware": _vm.defaultFirmware(comp.name),
                        "firmware-assigned": _vm.currentFirmware(comp.name),
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }